/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API_BASE_URL, API_BASE_URL_DEV } from '../config';
var LectaPaymentServiceSDK = /** @class */ (function () {
    function LectaPaymentServiceSDK(props) {
        var _a;
        this.userId = (_a = props.userId) !== null && _a !== void 0 ? _a : null;
        this.serviceToken = props.serviceToken;
        this.baseUrl = props.mode === 'prod' ? API_BASE_URL : API_BASE_URL_DEV;
        if (props.mode !== 'prod')
            console.log('SDK initialized', this.userId, this.serviceToken, this.baseUrl);
    }
    LectaPaymentServiceSDK.prototype.updateUserId = function (id) {
        this.userId = id;
    };
    LectaPaymentServiceSDK.prototype.getCart = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = id ? "cart/get/?cart_id=".concat(id) : 'cart/get/';
                        return [4 /*yield*/, this._apiCall({
                                url: url,
                                method: 'get'
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype.addProductsToCart = function (cartId, productNomenclatures) {
        return __awaiter(this, void 0, void 0, function () {
            var body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = [];
                        productNomenclatures.forEach(function (pn) {
                            body.push({
                                cart: cartId,
                                position: pn
                            });
                        });
                        return [4 /*yield*/, this._apiCall({
                                url: 'cart/add_position/',
                                method: 'post',
                                body: body
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype.removeProductFromCart = function (cartId, productNomenclature) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._apiCall({
                            url: "cart/".concat(cartId, "/delete_position/?position=").concat(productNomenclature),
                            method: 'delete'
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype.emptyCart = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._apiCall({
                            url: "cart/".concat(id, "/clean/"),
                            method: 'delete'
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype.applyPromocodeToCart = function (cartId, promocode) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._apiCall({
                            url: "cart/".concat(cartId, "/apply_promocode/"),
                            method: 'post',
                            body: { promocode: promocode }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype.getCartPaymentLink = function (cartId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._apiCall({
                            url: "cart/".concat(cartId, "/payment_url/"),
                            method: 'get'
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LectaPaymentServiceSDK.prototype._apiCall = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, method, body, headers, params, output, response, _a, _b, errors_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = props.url, method = props.method, body = props.body;
                        if (!this.serviceToken)
                            throw new Error('Service token not provided!');
                        headers = {
                            'Content-Type': 'application/json',
                            'X-Service-Token': this.serviceToken
                        };
                        if (this.userId)
                            headers['X-User-Id'] = this.userId;
                        params = {
                            method: method,
                            headers: headers,
                            mode: 'cors'
                        };
                        if (body)
                            params.body = JSON.stringify(body);
                        output = {
                            data: null,
                            errors: null,
                            status: null
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, fetch("".concat(this.baseUrl).concat(url), params)];
                    case 2:
                        response = _c.sent();
                        output.status = response.status;
                        if (!response.ok) return [3 /*break*/, 4];
                        _a = output;
                        return [4 /*yield*/, response.json()];
                    case 3:
                        _a.data = _c.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        _b = output;
                        return [4 /*yield*/, response.json()];
                    case 5:
                        _b.errors = _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        errors_1 = _c.sent();
                        output.errors = errors_1;
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, output];
                }
            });
        });
    };
    return LectaPaymentServiceSDK;
}());
export { LectaPaymentServiceSDK };
